import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import MassMessaging2 from './index';
import MassMessagingLegacy from '../../../../components/Routes/Messaging/MassMessaging';

const MassMessagingGate = props => {
  const flags = useFlags();
  if (flags.events) return <MassMessaging2 {...props} />;
  return <MassMessagingLegacy {...props} />;
};

export default MassMessagingGate;
